/**
 * Tune Wizard standalone route.
 *
 * Mounts the v137 TuningWizard with a fresh useSetups so the wizard binds
 * to whatever the user's active setup is. Adds the same forge-nav as the
 * other surfaces so testers can move between Tune and Wind-Drift / Spine
 * without back-button gymnastics.
 *
 * Theming: dark page (matches the wizard's tailwind zinc-950 background).
 * The Build Review surface is light because it ships under a cream Shopify
 * page; the wizard ships under its own dark Shopify page wrapper at
 * /pages/tune (the iframe shell background is also dark so there's no
 * cream-flash on load).
 */

import { useSetups } from '@/hooks/useSetups';
import { useSubscription } from '@/hooks/useSubscription';
import { TuningWizard } from './TuningWizard';
import './tune.css';

export function TunePage() {
  const setups = useSetups();
  const { hasTier } = useSubscription();
  const unlocked = hasTier('hunter');

  return (
    <div className="tune-page">
      <nav className="forge-nav">
        <a href="https://sparrowexpeditions.com/pages/the-forge" target="_top">The Forge</a>
        <a href="/wind-drift.html">Wind-Drift</a>
        <a href="/build-review.html">Build Review</a>
        <a href="/tune.html" className="active">Tune Wizard</a>
        <a href="/range.html">Range Log</a>
        <a href="/bows.html">My Bows</a>
        <a href="/arrows.html">My Arrows</a>
        <a href="/spine.html">Spine</a>
        <a href="/pages/methods#ashby" target="_blank" rel="noopener">Methods</a>
      </nav>

      {!unlocked ? (
        <div className="tune-empty">
          <h2>The Tuning Wizard is a Hunter feature</h2>
          <p>
            The full 12-step bow-tuning wizard — grip, cam timing, paper,
            bareshaft, broadhead — unlocks with Sparrow Hunter: $6/mo or
            $60/yr (2 months free). The Free tier keeps the builder,
            recommender, spine, wind-drift and more.
          </p>
          <a href="https://sparrowexpeditions.com/pages/pricing?plan=hunter" target="_top">See plans →</a>
        </div>
      ) : setups.activeSetup ? (
        <div className="tune-shell">
          <TuningWizard setups={setups} />
        </div>
      ) : (
        <div className="tune-empty">
          <h2>Pick a setup to tune</h2>
          <p>
            Tuning is bound to a Setup (bow + sight + arrow). Save a bow on
            My Bows first, then come back here to start the wizard.
          </p>
          <a href="/bows.html">Open My Bows →</a>
        </div>
      )}
    </div>
  );
}
